
























































import { Component, Vue, Prop } from 'vue-property-decorator';

import { Event } from '../models/event';
import EventInfoNotification from './EventInfoNotification.vue';
import EventInfoPlace from './EventInfoPlace.vue';
import EventTimeline from './EventTimeline.vue';

@Component({
  components: {
    EventTimeline,
    EventInfoPlace,
    EventInfoNotification,
  },
})
export default class EventInfoCoreComponent extends Vue {
  @Prop({ required: true, type: Event })
  event!: Event;

  private place: any = null;

  private isLoadingCepSearch: boolean = null;

  onUpdateDates() {
    this.event.info.dates.splice(
      this.event.info.dates.length - 1,
      1,
      this.event.info.dates[this.event.info.dates.length - 1],
    );
  }
}
